import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDowninline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7 11.583V0h2v11.589l4.336-4.337 1.415 1.415-6.04 6.04a1 1 0 0 1-1.415 0l-6.04-6.04L2.67 7.252 7 11.582z",
		fill: "currentColor"
	})
});
export default SvgArrowDowninline;
